import usePartner from '@platform-ui-common/hooks/contexts/usePartner.js';
import React, { ReactNode, useEffect, useState } from 'react';

export const PageTitleContext = React.createContext<{
  setPageTitleContext: (value?: string) => void;
}>(null);

export function PageTitleProvider({ children }: { children: ReactNode }): JSX.Element {
  const [pageTitleContext, setPageTitleContext] = useState<string>(null);
  const partner = usePartner();
  const platformName = partner?.whitelabeling?.platformName ?? 'Beam';

  useEffect(() => {
    document.title = pageTitleContext ? `${pageTitleContext} - ${platformName}` : platformName;
  }, [pageTitleContext, platformName]);

  return (
    <PageTitleContext.Provider value={{ setPageTitleContext }}>
      {children}
    </PageTitleContext.Provider>
  );
}
